import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Enums from '../../enums';

class AdsClickApp extends React.Component {
    constructor(props) {
        super(props);
        Tools.init();
        API.init(this);

        this.state = {
            id: this.props.match.params["id"] || "",
            list: [],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "編號",
                "會員id",
                "點擊次數",
                "點擊時間"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData() {
        var tmpData = {
            adi: this.state.id
        };
        API.GetAdClickIndex(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index) {
        // console.log(index);
        // window.open("detail.html?id="+index);
        alert("[TODO] API&資料待補", index);
    }

    onDataUpdated(data) {
        console.log(this);
        if (data && data.data) {
            console.log(data);
            const tmp = [];
            /* {
                "data": [
                    {
                        "ct": 1552053503348,
                        "ac": "admin",
                        "count": 3
                    }
                ],
                "total_click": 3
            } */
            for (let index in data.data) {
                const tmpObj = data.data[index];
                const i = parseInt(index) + 1;
                // "編號",
                // "會員id",
                // "點擊次數",
                // "點擊時間"
                tmp.push({
                    key: i,
                    data: [
                        i,
                        tmpObj.ac,
                        tmpObj.count,
                        Tools.getFormatDate(tmpObj.ct)
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list}
                    fields={fields}
                    title={"廣告點擊列表"}
                    onRowClicked={onListViewClicked} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(AdsClickApp),
//     document.getElementById('root')
// );
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdsClickApp))